module.exports = __webpack_public_path__ + "img/location.538553c7.svg";